module.exports = __webpack_public_path__ + "static/media/perguntas.951631ce.svg";